"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.howAppIsRunning = exports.findOutEnv = exports.ENV_URLS = void 0;
// DEPRECATED IT WILL CONTINUE ON UTILS/ENVIRONMENT
const TELCO_ENVS = {
  DEV: {
    endpoint: 'http://tehrhadx.serv.dev.dc.es.telefonica:11010',
    headers: {}
  },
  QA: {
    endpoint: 'http://tehrhad5.serv.test.dc.es.telefonica:11010',
    headers: {}
  },
  PROD: {
    endpoint: 'https://www.movistar.es',
    headers: {}
  }
};
const CUSTOMIZER_ENVS = {
  DEV: {
    endpoint: 'https://customizer-dot-mov-dev15.appspot.com',
    headers: {}
  },
  QA: {
    endpoint: 'https://qa.customizer.col.movistar.es',
    headers: {
      withCredentials: true
    }
  },
  PROD: {
    endpoint: 'https://customizer.col.movistar.es',
    headers: {
      timeout: 10000,
      withCredentials: true
    }
  }
};
const CATALOGUE_ENVS = {
  QA: {
    endpoint: 'https://qa.catalogue.col.movistar.es',
    headers: {
      withCredentials: true
    }
  },
  PROD: {
    endpoint: 'https://catalogue.col.movistar.es',
    headers: {
      withCredentials: true
    }
  }
};
const ENV_URLS = [{
  name: 'qa',
  host: 'col10mgmt.tsm.inet',
  custo: CUSTOMIZER_ENVS.QA,
  catalogue: CATALOGUE_ENVS.QA,
  telco: TELCO_ENVS.QA
}, {
  name: 'qa',
  host: 'movistar.es.inte',
  custo: CUSTOMIZER_ENVS.QA,
  catalogue: CATALOGUE_ENVS.QA,
  telco: TELCO_ENVS.DEV
}, {
  name: 'qa',
  host: 'movistar.es.cert',
  custo: CUSTOMIZER_ENVS.QA,
  catalogue: CATALOGUE_ENVS.QA,
  telco: TELCO_ENVS.QA
}, {
  name: 'qa',
  host: 'qa.cms.col.movistar.es',
  custo: CUSTOMIZER_ENVS.QA,
  catalogue: CATALOGUE_ENVS.QA,
  telco: TELCO_ENVS.QA
}, {
  name: 'qa',
  host: 'tcolgranja1.es.telefonica',
  custo: CUSTOMIZER_ENVS.QA,
  catalogue: CATALOGUE_ENVS.PROD,
  telco: TELCO_ENVS.PROD
}, {
  name: 'qa',
  host: 'tcolgranja2.es.telefonica',
  custo: CUSTOMIZER_ENVS.QA,
  catalogue: CATALOGUE_ENVS.PROD,
  telco: TELCO_ENVS.PROD
}, {
  name: 'dev',
  host: '127.0.0.1:8089',
  custo: CUSTOMIZER_ENVS.DEV,
  catalogue: CATALOGUE_ENVS.QA,
  telco: TELCO_ENVS.QA
}, {
  name: 'prod',
  host: 'prod.cms.col.movistar.es',
  custo: CUSTOMIZER_ENVS.PROD,
  catalogue: CATALOGUE_ENVS.PROD,
  telco: TELCO_ENVS.PROD
}, {
  name: 'prod',
  host: 'movistar.es',
  custo: CUSTOMIZER_ENVS.PROD,
  catalogue: CATALOGUE_ENVS.PROD,
  telco: TELCO_ENVS.PROD
}, {
  name: 'prod',
  host: 'atencionalcliente.movistar.es',
  custo: CUSTOMIZER_ENVS.PROD,
  catalogue: CATALOGUE_ENVS.PROD,
  telco: TELCO_ENVS.PROD
}, {
  name: 'prod',
  host: 'web.movistar.es',
  custo: CUSTOMIZER_ENVS.PROD,
  catalogue: CATALOGUE_ENVS.PROD,
  telco: TELCO_ENVS.PROD
}];
exports.ENV_URLS = ENV_URLS;

const findOutEnv = (defaultHost = 'movistar.es') => {
  let res = ENV_URLS.find(item => item.host === defaultHost);

  try {
    const myUrl = document.location.href;
    const item = ENV_URLS.find(envUrl => {
      const {
        host
      } = envUrl;
      return myUrl.indexOf(host) !== -1;
    });

    if (item) {
      res = item;
    }
  } catch (err) {
    return res;
  }

  return res;
};

exports.findOutEnv = findOutEnv;

const howAppIsRunning = () => {
  const {
    NODE_ENV
  } = process.env;
  return NODE_ENV;
};

exports.howAppIsRunning = howAppIsRunning;

//# sourceMappingURL=index.js.map